import React, { useState, useEffect } from "react";
import HomeHero from "./HomeHero";
import HomeAbout from "./HomeAbout";
import HomeProjects from "./HomeProjects";
import WhyUs from "./WhyUs";
import HomeServices from "./HomeServices";
import HomeContact from "./HomeContact";
import Testimonial from "./Testimonial";
import HomeSlider from "./HomeSlider";
import HomePopup from "./HomePopup";

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const popupShown = sessionStorage.getItem("popupShown");

    if (!popupShown) {
      setTimeout(() => {
        setShowPopup(true);
        sessionStorage.setItem("popupShown", "true");
      }, 25000); 
    }
  }, []);

  return (
    <div>
      {showPopup && <HomePopup onClose={() => setShowPopup(false)} />}

      <HomeHero />
      <HomeSlider />
      <HomeAbout />
      <HomeProjects />
      <WhyUs />
      <HomeServices />
      <HomeContact />
      <Testimonial />
    </div>
  );
};

export default Home;
